import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import { GMap } from './GMap';

export default withStyles(styles)(GMap);
